import type { PainTrendConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(config: PainTrendConfig): WidgetValidationResult {
  if (config.label.trim().length === 0) {
    return { ok: false, errors: { label: "Etikett kan ikke være tom." } };
  }
  return { ok: true };
}
